jQuery(document).ready(function ($) {
  $('body').attr('onselectstart', 'return false');
  $('body').attr('unselectable', 'on');
  $('body').css('-moz-user-select', 'none');
});
